var _path, _circle, _path2, _path3, _circle2, _path4, _path5, _circle3, _path6, _path7, _circle4, _path8, _path9, _circle5, _path10, _circle6, _path11, _circle7, _circle8, _circle9, _circle10, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 749.023,
    height: 653.882,
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.154 632.307s1.487-31.159 31.97-27.537",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132.541,
    cy: 587.398,
    r: 15.257,
    fill: "#ffcb37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6b00",
    d: "M130.058 613.09h4.307v30.147h-4.307z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M643.6 637.63s1.488-31.16 31.972-27.538",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 634.987,
    cy: 592.721,
    r: 15.257,
    fill: "#ffcb37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6b00",
    d: "M632.505 618.413h4.307v30.147h-4.307z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M717.05 642.952s1.488-31.159 31.973-27.537",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 708.438,
    cy: 598.043,
    r: 15.257,
    fill: "#ffcb37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6b00",
    d: "M705.956 623.735h4.307v30.147h-4.307z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.443 617.403s1.487-31.158 31.97-27.537",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 252.83,
    cy: 572.495,
    r: 15.257,
    fill: "#ffcb37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6b00",
    d: "M250.347 598.187h4.307v30.147h-4.307z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.704 622.726s1.487-31.159 31.97-27.537",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.09,
    cy: 577.818,
    r: 15.257,
    fill: "#ffcb37"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6b00",
    d: "M23.608 603.51h4.307v30.147h-4.307z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 403.591,
    cy: 402.354,
    r: 166.228,
    fill: "#45dcaf"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M298.94 415.697a44.01 44.01 0 0133.759-15.788 44.014 44.014 0 0133.76 15.788 48.91 48.91 0 0015.13-35.363c0-26.82-22.07-48.89-48.89-48.89s-48.89 22.07-48.89 48.89a48.907 48.907 0 0015.13 35.363zM430.945 415.697a44.01 44.01 0 0133.759-15.788 44.014 44.014 0 0133.76 15.788 48.91 48.91 0 0015.13-35.363c0-26.82-22.07-48.89-48.89-48.89-26.821 0-48.891 22.07-48.891 48.89a48.908 48.908 0 0015.132 35.363z",
    fill: "#fff",
    fillRule: "nonzero"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.021,
    cy: 363.686,
    r: 16.818,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.021,
    cy: 363.686,
    r: 16.818,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.809,
    cy: 443.911,
    r: 19.556,
    fill: "#ff6b00"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 508.706,
    cy: 443.911,
    r: 19.556,
    fill: "#ff6b00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M396.257 404.798l-14.667 63.558 24.445-24.445zM471.62 649.252l-16.651-13.976.388 13.976h-5.172l-.413-14.778-22.483 14.778h-9.412l31.727-20.854-1.23-43.789-.917-33.07 5.159-.143.93 33.213 1.229 43.75 24.887 20.893zM393.39 649.252l-16.652-13.976.388 13.976h-5.158l-.414-14.778-22.483 14.778h-9.412l31.714-20.854-1.228-43.789-.918-33.07 5.17-.143.932 33.213 1.215 43.75 24.888 20.893z",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M406.035 223.903c-4.561 0-8.585 3.543-11.275 8.985-2.371-8.183-7.352-13.874-13.17-13.874a8.797 8.797 0 00-1.174.197c-2.237-8.737-7.434-14.865-13.493-14.865-8.101 0-14.667 10.945-14.667 24.446 0 13.501 6.566 24.445 14.667 24.445a8.824 8.824 0 001.174-.197c2.236 8.737 7.434 14.864 13.493 14.864 4.56 0 8.585-3.543 11.275-8.985 2.37 8.183 7.353 13.874 13.17 13.874 8.1 0 14.667-10.944 14.667-24.445 0-13.5-6.566-24.445-14.667-24.445z",
    fill: "#45dcaf",
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.564 465.35c-26.82 0-48.89-22.07-48.89-48.892v-24.445c0-26.82 22.07-48.89 48.89-48.89zM559.617 343.12c26.82 0 48.89 22.07 48.89 48.891v24.445c0 26.821-22.07 48.891-48.89 48.891V343.12z",
    fill: "#ffcb37",
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M585.237 395.852h-7.757c0-98.377-80.036-178.414-178.414-178.414-98.378 0-178.414 80.037-178.414 178.414h-7.757c0-102.655 83.516-186.17 186.17-186.17 102.656 0 186.172 83.515 186.172 186.17z",
    fill: "#ffcb37",
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.86 246.345l.003-.003-3.645-1.518-15.376-6.5-5.512-2.33-.423 1.068-7.404 18.694 20.837 8.82.109.098-1.404 3.311a5.903 5.903 0 00-.49.956c-.983 2.483.875 4.954 2.63 5.65 1.757.695 3.978-.755 4.962-3.238.97-2.45.022-5.562-1.69-6.314l.002-.003-3.645-1.518-12.466-4.846 7.123-17.985-1.056-.418-7.126 17.992-1.541-.6L113.9 239.6l.189.08 14.654 6.202.109.1-1.404 3.31a5.903 5.903 0 00-.49.956c-.983 2.483.874 4.954 2.63 5.65 1.757.695 3.978-.755 4.96-3.238.972-2.45.023-5.562-1.688-6.314z",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.98 292.24c-7.563-4.326-6.05-13.816-6.05-13.816-.19-6.165-5.283-5.293-5.283-5.293l-1.854.424a5.63 5.63 0 00-2.757-.51l-2.82.474c6.422 1.51 5.894 6.881 5.894 6.881l.9 6.281-16.826-6.788 1.932-4.555a8.18 8.18 0 00.68-1.327c1.366-3.45-1.214-6.88-3.653-7.847-2.44-.966-5.524 1.048-6.89 4.497-1.348 3.402-.031 7.725 2.346 8.77l-.002.003 5.062 2.108.037-.12zm-8.543-11.037l.539 6.012a13.874 13.874 0 01-2.526-9.207 5.822 5.822 0 00-1.126-3.225 6.84 6.84 0 013.113 6.42zM76.633 203.328l.002-.004-5.062-2.108-21.154-8.224 5.339-4.75c2.157-2.876 6.255-3.547 9.217-1.51l-1.657-2.463s-3.115-4.123-7.475.24c0 0-5.395 7.953-13.87 5.926l28.94 12.25.153.136-1.95 4.6c-.267.42-.495.863-.68 1.326-1.366 3.45 1.214 6.88 3.653 7.846 2.439.966 5.524-1.047 6.89-4.496 1.348-3.403.03-7.725-2.346-8.769zM154.08 176.413l-1.951 4.598a8.261 8.261 0 00-.68 1.327c-1.366 3.45 1.214 6.881 3.653 7.847 2.439.966 5.524-1.047 6.89-4.497 1.348-3.402.03-7.724-2.346-8.769l.002-.004-5.061-2.108-17.315-6.73 9.893-24.98-1.466-.58-9.898 24.988-2.141-.832 9.936-25.087.262.111 20.353 8.614.152.138-1.95 4.598a8.185 8.185 0 00-.681 1.327c-1.366 3.45 1.214 6.881 3.653 7.847 2.44.966 5.525-1.047 6.89-4.497 1.348-3.402.03-7.725-2.346-8.769l.002-.004-5.061-2.108-20.685-8.744h-.001l-.671-.284-7.655-3.236-10.87 27.447 28.94 12.25zM62.367 35.843l.004-.007-8.713-3.628-36.416-14.156 9.19-8.178S32.547 1.391 42.3 7.275l-2.852-4.239s-5.362-7.099-12.868.412c0 0-9.287 13.691-23.874 10.201l49.819 21.086.26.237-3.356 7.915a14.029 14.029 0 00-1.171 2.285c-2.352 5.938 2.09 11.844 6.288 13.507 4.199 1.663 9.51-1.802 11.862-7.74 2.319-5.857.052-13.298-4.04-15.096z",
    fill: "#ffcb37",
    fillRule: "nonzero"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.107 154.757c-18.084-10.34-14.466-33.03-14.466-33.03-.455-14.74-12.633-12.654-12.633-12.654l-4.433 1.011a13.465 13.465 0 00-6.591-1.219L44.242 110c15.353 3.607 14.092 16.451 14.092 16.451l2.15 15.017-40.23-16.229 4.62-10.89a19.422 19.422 0 001.627-3.174c3.267-8.247-2.902-16.45-8.734-18.76-5.832-2.31-13.208 2.503-16.474 10.75-3.222 8.135-.073 18.47 5.61 20.966l-.005.01L19 129.181l.09-.285zm-20.43-26.386l1.296 14.424c-7.596-10.083-6.043-22.062-6.043-22.062a13.932 13.932 0 00-2.694-7.712c8.725 5.222 7.442 15.35 7.442 15.35z",
    fill: "#ff6b00",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b421a13386b45e3e693bcd20093f9cd7.svg";
export { ForwardRef as ReactComponent };